import { Link } from "react-router-dom";
import { Heart, MapPin, Eye } from "lucide-react";
import { fileUrl, formatPrice, formatDate, isFeatured } from "@/lib/api";

export function ListingCard({ listing, isFavorite, onToggleFavorite }) {
  const img = listing.images?.[0];
  return (
    <div data-testid={`listing-card-${listing.listing_id}`} className="border-2 border-black bg-white hard-shadow-hover relative">
      <Link to={`/listing/${listing.listing_id}`} className="block no-underline text-black hover:no-underline">
        <div className="aspect-[4/3] bg-[#F2F2F2] border-b-2 border-black overflow-hidden relative">
          {img ? (
            <img src={fileUrl(img)} alt={listing.title} className="w-full h-full object-cover" loading="lazy" />
          ) : (
            <div className="w-full h-full flex items-center justify-center font-mono-data text-xs uppercase text-gray-500">NO IMAGE</div>
          )}
          <div className="absolute top-2 left-2 bg-white border border-black px-2 py-0.5 font-mono-data text-[10px] uppercase">
            {listing.category?.replace("-", " ")}
          </div>
          {isFeatured(listing) && (
            <div className="absolute bottom-2 left-2 bg-[#0000EE] text-white border border-black px-2 py-0.5 font-mono-data text-[10px] uppercase font-bold" data-testid="featured-badge">★ Featured</div>
          )}
        </div>
        <div className="p-3">
          <div className="font-display text-xl truncate">{listing.title}</div>
          <div className="font-mono-data text-2xl font-bold mt-1">{formatPrice(listing.price, listing.currency)}</div>
          <div className="flex items-center justify-between mt-2 text-xs font-mono-data uppercase text-gray-700">
            <span className="flex items-center gap-1 truncate"><MapPin size={12} strokeWidth={2.5} /> {listing.location}</span>
            <span className="flex items-center gap-1"><Eye size={12} strokeWidth={2.5} /> {listing.views || 0}</span>
          </div>
          <div className="text-xs font-mono-data uppercase text-gray-500 mt-1">{formatDate(listing.created_at)}</div>
        </div>
      </Link>
      {onToggleFavorite && (
        <button
          data-testid={`fav-btn-${listing.listing_id}`}
          onClick={(e) => { e.preventDefault(); onToggleFavorite(listing.listing_id); }}
          className={`absolute top-2 right-2 border-2 border-black p-1.5 ${isFavorite ? "bg-[#FF0000] text-white" : "bg-white text-black hover:bg-yellow-100"}`}
          aria-label="Toggle favorite"
        >
          <Heart size={16} strokeWidth={2.5} fill={isFavorite ? "#fff" : "none"} />
        </button>
      )}
    </div>
  );
}

export function ListingRow({ listing }) {
  return (
    <Link
      data-testid={`listing-row-${listing.listing_id}`}
      to={`/listing/${listing.listing_id}`}
      className="grid grid-cols-12 gap-2 border-b border-black px-3 py-2 row-hover text-black no-underline hover:no-underline items-center"
    >
      <div className="col-span-2 md:col-span-1 font-mono-data text-xs uppercase text-gray-600">{formatDate(listing.created_at)}</div>
      <div className="col-span-6 md:col-span-7 truncate">
        {isFeatured(listing) && (
          <span className="bg-[#0000EE] text-white px-1.5 py-0.5 font-mono-data text-[10px] uppercase font-bold mr-2">★ FEATURED</span>
        )}
        <span className="link-blue underline-offset-2 hover:underline">{listing.title}</span>
        <span className="text-gray-500 ml-2 hidden md:inline text-sm">— {listing.description?.slice(0, 80)}</span>
      </div>
      <div className="col-span-2 font-mono-data text-sm font-bold text-right md:text-left">{formatPrice(listing.price, listing.currency)}</div>
      <div className="col-span-2 font-mono-data text-xs uppercase text-gray-700 truncate text-right">{listing.location}</div>
    </Link>
  );
}
